import Constants from './Constants';
import Axios from 'axios';

const Log = (label, msg) => {
    if (!IsStringEmpty(process.env.NODE_ENV) && (process.env.NODE_ENV === 'development')) {
        msg !== '' && msg !== null && msg !== undefined
            ? console.log(label, msg)
            : console.log(label);
    }
}

const Error = (label, msg) => {
    if (!IsStringEmpty(process.env.NODE_ENV) && (process.env.NODE_ENV === 'development')) {
        msg !== '' && msg !== null && msg !== undefined
            ? console.error(label, msg)
            : console.error(label);
    }
}

const LogParsingError = (error, url, object) => {
    const errorMsg = error.toString();
    DumpParsingErrorLog(url, !IsStringEmpty(errorMsg) ? errorMsg : 'No response from server', object);
}

const DumpParsingErrorLog = async (url, message, object) => {
    if (!IsStringEmpty(process.env.NODE_ENV) && (process.env.NODE_ENV === 'production')) {
        const username = GetFromLocalStorage(Constants.KEY_USERNAME);
        const browserNetwork = navigator.connection ? (navigator.connection.downlink + 'Mbps (down) ' + navigator.connection.effectiveType) : 'Cant fetch';
        const userAgent = navigator.userAgent;
        const data = {
            username: IsStringEmpty(username) ? 'Anonymous' : username,
            url: url,
            message: message,
            network: browserNetwork,
            userAgent: userAgent,
            date: new Date().toString(),
            object: object
        }
        Axios.post(Constants.FIREBASE_PARSING_LOGS_URL, data);
    }
}

const DumpErrorLog = async (url, message) => {
    // if (!IsStringEmpty(process.env.NODE_ENV) && (process.env.NODE_ENV === 'production')) {
    //     const username = GetFromLocalStorage(Constants.KEY_USERNAME);
    //     const browserNetwork = navigator.connection ? (navigator.connection.downlink + 'Mbps (down) ' + navigator.connection.effectiveType) : 'Cant fetch';
    //     const userAgent = navigator.userAgent;
    //     const data = {
    //         username: IsStringEmpty(username) ? 'Anonymous' : username,
    //         url: url,
    //         message: message,
    //         network: browserNetwork,
    //         userAgent: userAgent,
    //         date: new Date().toString()
    //     }
    // Axios.post(Constants.FIREBASE_ERROR_LOGS_URL, data);
    // }
}

const SearchLogs = async (keywords) => {
    if (!IsStringEmpty(process.env.NODE_ENV) && (process.env.NODE_ENV === 'production')) {
        const username = GetFromLocalStorage(Constants.KEY_USERNAME)
        const data = {
            username: IsStringEmpty(username) ? 'Anonymous' : username,
            keywords: keywords,
            date: new Date().toString()
        }
        Axios.post(Constants.FIREBASE_SEARCH_LOGS_URL, data);
    }
}

const SearchByCategoryLogs = async (categoryName) => {
    if (!IsStringEmpty(process.env.NODE_ENV) && (process.env.NODE_ENV === 'production')) {
        const username = GetFromLocalStorage(Constants.KEY_USERNAME)
        const data = {
            username: IsStringEmpty(username) ? 'Anonymous' : username,
            categoryName: categoryName,
            date: new Date().toString()
        }
        Axios.post(Constants.FIREBASE_CATEGORY_LOGS_URL, data);
    }
}

const AddInLocalStorage = (key, value) => {
    // Log('SetItem -> ' + key, value);
    window.localStorage.setItem(key, value);
}

const GetFromLocalStorage = (key) => {
    // Log('GetItem -> ' + key + "'s Value ", window.localStorage.getItem(key));
    return window.localStorage.getItem(key);
}

const ClearLocalStorage = () => {
    // Log('Clearing Local Storage');
    return window.localStorage.clear();
}

const IsObjectEmpty = (obj) => {
    for (var key in obj) {
        try {
            if (obj.hasOwnProperty(key))
                return false;
        } catch (error) {
            if (Object.hasOwnProperty.bind(obj)(key))
                return false;
        }
    }
    return true;
}

const IsListEmpty = (list) => {
    if (list !== undefined && list !== null && list !== "null" && list.length > 0) {
        return false;
    }
    return true;
}

const IsStringEmpty = (str) => {
    if (str !== undefined && str !== null && str !== "null" && str !== '') {
        return false;
    }
    return true;
}

const cleanHTML = (html) => {
    var sanitizeHtml = require('sanitize-html');
    return sanitizeHtml(html);
}

const htmlToText = (html) => {
    const htmlToText = require('html-to-text');
    const text = htmlToText.fromString(html, { uppercaseHeadings: false });
    return text;
}

const parseQueryParams = (relativevUrl) => {
    const queryString = require('query-string');
    const parsedParams = queryString.parse(relativevUrl);
    return parsedParams;
}

const GetObjectClone = (obj) => {
    // return (Object.getPrototypeOf(obj) !== Object.prototype) ? obj : Object.keys(obj).reduce((acc, key) => (acc[key] = GetObjectClone(obj[key])), {})
    var output, v, key;
    output = Array.isArray(obj) ? [] : {};
    for (key in obj) {
        v = obj[key];
        output[key] = (typeof v === "object") ? GetObjectClone(v) : v;
    }
    return output;
}

const anPrefixForVowels = (text) => {
    if (!IsStringEmpty(text)) {
        const firstChar = text.charAt(0).toLowerCase();
        if (firstChar === 'a' || firstChar === 'e' || firstChar === 'i' || firstChar === 'o' || firstChar === 'u') {
            return 'an ';
        } else {
            return 'a ';
        }
    } else {
        return 'a ';
    }
}

const getTrimmedUsername = (text, length) => {
    const trimLength = IsStringEmpty(length) ? Constants.MAX_CHAR_FOR_USERNAME : length;
    if (!IsStringEmpty(text)) {
        if (text.length >= trimLength) {
            let updatedUsername = text.slice(0, (trimLength - 4));
            updatedUsername = updatedUsername + '...';

            return updatedUsername;
        } else {
            return text;
        }
    } else {
        return text;
    }
}

const getTrimmedChannelName = (text, length) => {
    const trimLength = IsStringEmpty(length) ? Constants.MAX_CHAR_FOR_CHANNEL : length;
    if (!IsStringEmpty(text)) {
        if (text.length >= trimLength) {
            let updatedChannel = text.slice(0, (trimLength - 4));
            updatedChannel = updatedChannel + '...';

            return updatedChannel;
        } else {
            return text;
        }
    } else {
        return text;
    }
}

const getTrimmedText = (text, length) => {
    if (!IsStringEmpty(text)) {
        if (text.length >= length) {
            let updatedText = text.slice(0, (length - 4));
            updatedText = updatedText + '...';

            return updatedText;
        } else {
            return text;
        }
    } else {
        return text;
    }
}

const toTitleCase = (str) => {
    let newstr = str.toLowerCase().split(" ");
    for (let i = 0; i < newstr.length; i++) {
        newstr[i] = newstr[i].charAt(0).toUpperCase() + newstr[i].substr(1).toLowerCase();
    }
    newstr = newstr.join(" ");
    return newstr;
}

const IsCookiePresent = (cname) => {
    if (cname !== undefined && cname !== null && cname !== "null" && cname.length > 0) {
        if (document.cookie.split(';').some((item) => item.trim().startsWith(cname + '='))) {
            return true
        } else {
            return false
        }
    }
    return true;
}

const forUserAcquisition = (affId) => {
    const cname = 'easy_affiliate';
    if (cname !== undefined && cname !== null && cname !== "null" && cname.length > 0) {
        if (document.cookie.split(';').some((item) => item.trim().startsWith(cname + '=') && item.trim().indexOf('aff_uid=' + affId + '&') !== -1)) {
            return true
        } else {
            return false
        }
    }
    return true;
}

const setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const formDataToJSON = (formData) => {
    let object = {};
    formData.forEach(function (value, key) {
        object[key] = value;
    });
    // return JSON.stringify(object);
    return object;
}

const isFacebookCampaign = () => {

    let isFacebookCampaign = false;

    const campaignDetails = JSON.parse(GetFromLocalStorage(Constants.MARKETING_CAMPAIGN_DETAILS));
    if (!IsObjectEmpty(campaignDetails) && campaignDetails !== null) {
        const utmSource = campaignDetails.utm_source;

        isFacebookCampaign = (!IsStringEmpty(utmSource) && (utmSource.toLowerCase() === 'facebook' || utmSource.toLowerCase() === 'instagram')) || (!IsStringEmpty(campaignDetails.fbclid)) ? true : false;
    }

    return isFacebookCampaign;
}

const pushDataForGTMEvent = (type, method, common) => {
    // alert(type + ' ' + method);
    if (window !== undefined && window !== null && window.dataLayer !== undefined && window.dataLayer !== null) {
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': type,
            'eventAction': !IsStringEmpty(common) ? 'Common Social - ' + type : type,
            'methodType': method
        })
    }
}

const calcPercentage = (a, b) => {
    let num1 = a, num2 = b, percentage = 0;
    if (!IsStringEmpty(num1) && !IsStringEmpty(num2) && num1 !== 0 && num2 !== 0) {
        percentage = (num1 / num2 * 100).toFixed(1);
    } else {
        percentage = 0;
    }
    return percentage;
}

const prependZero = (val) => {
    if (parseInt(val, 10) < 10) {
        return "0" + val;
    }
    return val;
}

const AddInSessionStorage = (key, value) => {
    // Log('SetItem -> ' + key, value);
    window.sessionStorage.setItem(key, value);
}

const GetFromSessionStorage = (key) => {
    // Log('GetItem -> ' + key + "'s Value ", window.localStorage.getItem(key));
    return window.sessionStorage.getItem(key);
}

export {
    Log, Error, AddInLocalStorage, GetFromLocalStorage, ClearLocalStorage, IsObjectEmpty, IsListEmpty, IsStringEmpty,
    cleanHTML, GetObjectClone, htmlToText, anPrefixForVowels, getTrimmedUsername, getTrimmedChannelName, getTrimmedText, DumpErrorLog, SearchLogs,
    SearchByCategoryLogs, parseQueryParams, toTitleCase, LogParsingError, IsCookiePresent, setCookie, forUserAcquisition, formDataToJSON, isFacebookCampaign, pushDataForGTMEvent, calcPercentage, prependZero, AddInSessionStorage, GetFromSessionStorage
};